var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.64,
    height: 13.176,
    viewBox: "0 0 14.64 13.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Excel",
    transform: "translate(-4 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13235",
    "data-name": "Path 13235",
    d: "M19.49,6H14.638A.638.638,0,0,0,14,6.638V9.3h5.49Z",
    transform: "translate(-6.34)",
    fill: "#169154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13236",
    "data-name": "Path 13236",
    d: "M14,33.054V35.69a.638.638,0,0,0,.638.638H19.49V33.054Z",
    transform: "translate(-6.34 -17.152)",
    fill: "#18482a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13237",
    "data-name": "Path 13237",
    d: "M14,15h5.49V18.3H14Z",
    transform: "translate(-6.34 -5.708)",
    fill: "#0c8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13238",
    "data-name": "Path 13238",
    d: "M14,24.005h5.49v3.312H14Z",
    transform: "translate(-6.34 -11.415)",
    fill: "#17472a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746",
    transform: "translate(13.15 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13239",
    "data-name": "Path 13239",
    d: "M33.852,6H29V9.3h5.49V6.638A.638.638,0,0,0,33.852,6Z",
    transform: "translate(-29 -6)",
    fill: "#29c27f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13240",
    "data-name": "Path 13240",
    d: "M29,33.054v3.274h4.852a.638.638,0,0,0,.638-.638V33.054H29Z",
    transform: "translate(-29 -23.152)",
    fill: "#27663f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13241",
    "data-name": "Path 13241",
    d: "M29,15h5.49V18.3H29Z",
    transform: "translate(-29 -11.708)",
    fill: "#19ac65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13242",
    "data-name": "Path 13242",
    d: "M29,24.005h5.49v3.312H29Z",
    transform: "translate(-29 -17.415)",
    fill: "#129652"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13243",
    "data-name": "Path 13243",
    d: "M10.7,21.32H4.615A.615.615,0,0,1,4,20.7v-6.09A.615.615,0,0,1,4.615,14H10.7a.615.615,0,0,1,.615.615V20.7A.615.615,0,0,1,10.7,21.32Z",
    transform: "translate(0 -5.072)",
    fill: "#0c7238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13244",
    "data-name": "Path 13244",
    d: "M9.629,19H10.5l.709,1.374L11.96,19h.816l-1.124,1.83,1.15,1.83h-.86l-.772-1.438L10.4,22.66H9.526l1.169-1.837Z",
    transform: "translate(-3.503 -8.242)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.5660b9c8fcd30a9a455768460f3a5e1e.svg";
export { ForwardRef as ReactComponent };